module.exports = __webpack_public_path__ + "static/home_04-6b1a08b9b580d2b544e61923d99cbd2d.webp";